import axios from 'axios';
import { isTokenExpired } from '@dtvgo/utils';

async function attemptRefreshToken(axiosInstance, refreshToken, businessUnit, msoProvider, getRegion, tokens, retries, maxRetries, waitTime) {
  try {
    const response = await axiosInstance.post(
      `${tokens.version}/oauth2/token`,
      {
        grantType: "refreshToken",
        refreshToken,
        region: await getRegion()
      },
      {
        headers: {
          "x-business-unit-type": businessUnit,
          ...msoProvider && businessUnit.toLowerCase().includes("mso") ? { "x-mso-provider": msoProvider } : {}
        }
      }
    );
    tokens.set(response.data);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const statusString = error.response?.status?.toString() ?? "";
      const isRetryable = error.code === "ECONNABORTED" || statusString === "408" || statusString[0] === "3" || statusString[0] === "5";
      const shouldRetry = retries < maxRetries && isRetryable;
      if (!shouldRetry) {
        const { id_token: idToken } = await tokens.get();
        const tokenExpired = isTokenExpired(idToken);
        if (tokenExpired || !isRetryable) {
          tokens.fail(error);
        }
        throw error;
      }
      await new Promise((resolve) => {
        setTimeout(resolve, (retries + 1) * waitTime);
      });
      return attemptRefreshToken(
        axiosInstance,
        refreshToken,
        businessUnit,
        msoProvider,
        getRegion,
        tokens,
        retries + 1,
        maxRetries,
        waitTime
      );
    }
    throw error;
  }
}
async function retryRefreshToken(axiosInstance, refreshToken, businessUnit, msoProvider, getRegion, tokens, maxRetries = 2, waitTime = 2e3) {
  return attemptRefreshToken(
    axiosInstance,
    refreshToken,
    businessUnit,
    msoProvider,
    getRegion,
    tokens,
    0,
    maxRetries,
    waitTime
  );
}

export { retryRefreshToken };
//# sourceMappingURL=refresh.js.map
